import client from '@infinitro/global';
import gql from 'graphql-tag';
import { readable } from 'svelte/store';
export var BetTypeEnum;
(function (BetTypeEnum) {
    BetTypeEnum["casino"] = "casino";
    BetTypeEnum["traditional"] = "traditional";
})(BetTypeEnum || (BetTypeEnum = {}));
export var CacheControlScope;
(function (CacheControlScope) {
    CacheControlScope["PRIVATE"] = "PRIVATE";
    CacheControlScope["PUBLIC"] = "PUBLIC";
})(CacheControlScope || (CacheControlScope = {}));
export var CasinoGameEnum;
(function (CasinoGameEnum) {
    CasinoGameEnum["blackjack"] = "blackjack";
    CasinoGameEnum["crash"] = "crash";
    CasinoGameEnum["dice"] = "dice";
    CasinoGameEnum["hilo"] = "hilo";
    CasinoGameEnum["limbo"] = "limbo";
    CasinoGameEnum["mines"] = "mines";
    CasinoGameEnum["plinko"] = "plinko";
    CasinoGameEnum["roulette"] = "roulette";
    CasinoGameEnum["soft"] = "soft";
    CasinoGameEnum["wheel"] = "wheel";
})(CasinoGameEnum || (CasinoGameEnum = {}));
export var CryptoNetworkEnum;
(function (CryptoNetworkEnum) {
    CryptoNetworkEnum["arb"] = "arb";
    CryptoNetworkEnum["ava"] = "ava";
    CryptoNetworkEnum["bnb"] = "bnb";
    CryptoNetworkEnum["btc"] = "btc";
    CryptoNetworkEnum["cro"] = "cro";
    CryptoNetworkEnum["doge"] = "doge";
    CryptoNetworkEnum["eth"] = "eth";
    CryptoNetworkEnum["ftm"] = "ftm";
    CryptoNetworkEnum["goerli"] = "goerli";
    CryptoNetworkEnum["ltc"] = "ltc";
    CryptoNetworkEnum["mumbai"] = "mumbai";
    CryptoNetworkEnum["polygon"] = "polygon";
    CryptoNetworkEnum["sepolia"] = "sepolia";
    CryptoNetworkEnum["testava"] = "testava";
    CryptoNetworkEnum["testbsc"] = "testbsc";
    CryptoNetworkEnum["testcro"] = "testcro";
})(CryptoNetworkEnum || (CryptoNetworkEnum = {}));
export var CurrencyEnum;
(function (CurrencyEnum) {
    CurrencyEnum["arb"] = "arb";
    CurrencyEnum["ava"] = "ava";
    CurrencyEnum["bnb"] = "bnb";
    CurrencyEnum["btc"] = "btc";
    CurrencyEnum["cro"] = "cro";
    CurrencyEnum["dai"] = "dai";
    CurrencyEnum["dash"] = "dash";
    CurrencyEnum["demo"] = "demo";
    CurrencyEnum["doge"] = "doge";
    CurrencyEnum["eth"] = "eth";
    CurrencyEnum["ftm"] = "ftm";
    CurrencyEnum["ltc"] = "ltc";
    CurrencyEnum["matic"] = "matic";
    CurrencyEnum["usdc"] = "usdc";
    CurrencyEnum["usdt"] = "usdt";
})(CurrencyEnum || (CurrencyEnum = {}));
export var DiceRollConditionEnum;
(function (DiceRollConditionEnum) {
    DiceRollConditionEnum["over"] = "over";
    DiceRollConditionEnum["under"] = "under";
})(DiceRollConditionEnum || (DiceRollConditionEnum = {}));
export var FiatCurrencyEnum;
(function (FiatCurrencyEnum) {
    FiatCurrencyEnum["EUR"] = "EUR";
    FiatCurrencyEnum["JPY"] = "JPY";
    FiatCurrencyEnum["USD"] = "USD";
})(FiatCurrencyEnum || (FiatCurrencyEnum = {}));
export var FiatTypeEnum;
(function (FiatTypeEnum) {
    FiatTypeEnum["AED"] = "AED";
    FiatTypeEnum["AUD"] = "AUD";
    FiatTypeEnum["BRL"] = "BRL";
    FiatTypeEnum["CAD"] = "CAD";
    FiatTypeEnum["CHF"] = "CHF";
    FiatTypeEnum["CZK"] = "CZK";
    FiatTypeEnum["DKK"] = "DKK";
    FiatTypeEnum["EUR"] = "EUR";
    FiatTypeEnum["GBP"] = "GBP";
    FiatTypeEnum["HKD"] = "HKD";
    FiatTypeEnum["JPY"] = "JPY";
    FiatTypeEnum["NZD"] = "NZD";
    FiatTypeEnum["PLN"] = "PLN";
    FiatTypeEnum["QAR"] = "QAR";
    FiatTypeEnum["SAR"] = "SAR";
    FiatTypeEnum["SEK"] = "SEK";
    FiatTypeEnum["SGD"] = "SGD";
    FiatTypeEnum["TRY"] = "TRY";
    FiatTypeEnum["USD"] = "USD";
})(FiatTypeEnum || (FiatTypeEnum = {}));
export var PlaymodeEnum;
(function (PlaymodeEnum) {
    PlaymodeEnum["FUN"] = "FUN";
    PlaymodeEnum["REAL"] = "REAL";
})(PlaymodeEnum || (PlaymodeEnum = {}));
export var SoftGameCatEnum;
(function (SoftGameCatEnum) {
    SoftGameCatEnum["blackjacks"] = "blackjacks";
    SoftGameCatEnum["jackpots"] = "jackpots";
    SoftGameCatEnum["livecasino"] = "livecasino";
    SoftGameCatEnum["slots"] = "slots";
    SoftGameCatEnum["tablegames"] = "tablegames";
    SoftGameCatEnum["videopoker"] = "videopoker";
    SoftGameCatEnum["virtualsports"] = "virtualsports";
})(SoftGameCatEnum || (SoftGameCatEnum = {}));
export var SortByEnum;
(function (SortByEnum) {
    SortByEnum["ATOZ"] = "ATOZ";
    SortByEnum["New"] = "New";
    SortByEnum["Popular"] = "Popular";
    SortByEnum["ZTOA"] = "ZTOA";
})(SortByEnum || (SortByEnum = {}));
export var UserEventNameEnum;
(function (UserEventNameEnum) {
    UserEventNameEnum["AVAILABLE_BALANCE"] = "AVAILABLE_BALANCE";
    UserEventNameEnum["DEPOSIT_COMPLETE"] = "DEPOSIT_COMPLETE";
    UserEventNameEnum["DEPOSIT_PENDING"] = "DEPOSIT_PENDING";
    UserEventNameEnum["REWARD_CREDIT"] = "REWARD_CREDIT";
    UserEventNameEnum["TERMINATE_SESSION"] = "TERMINATE_SESSION";
    UserEventNameEnum["WITHDRAW_COMPLETE"] = "WITHDRAW_COMPLETE";
    UserEventNameEnum["WITHDRAW_PENDING"] = "WITHDRAW_PENDING";
})(UserEventNameEnum || (UserEventNameEnum = {}));
export var WalletTypeEnum;
(function (WalletTypeEnum) {
    WalletTypeEnum["VAULT"] = "VAULT";
    WalletTypeEnum["WALLET"] = "WALLET";
})(WalletTypeEnum || (WalletTypeEnum = {}));
export var WithdrawFeeEnum;
(function (WithdrawFeeEnum) {
    WithdrawFeeEnum["FAST"] = "FAST";
    WithdrawFeeEnum["SLOW"] = "SLOW";
    WithdrawFeeEnum["STANDARD"] = "STANDARD";
})(WithdrawFeeEnum || (WithdrawFeeEnum = {}));
export var DateFilterEnum;
(function (DateFilterEnum) {
    DateFilterEnum["ALL"] = "ALL";
    DateFilterEnum["MONTH"] = "MONTH";
    DateFilterEnum["WEEK"] = "WEEK";
})(DateFilterEnum || (DateFilterEnum = {}));
export var GuessEnum;
(function (GuessEnum) {
    GuessEnum["equal"] = "equal";
    GuessEnum["higher"] = "higher";
    GuessEnum["higherEqual"] = "higherEqual";
    GuessEnum["lower"] = "lower";
    GuessEnum["lowerEqual"] = "lowerEqual";
    GuessEnum["skip"] = "skip";
})(GuessEnum || (GuessEnum = {}));
export var LanguageEnum;
(function (LanguageEnum) {
    LanguageEnum["bi"] = "bi";
    LanguageEnum["cs"] = "cs";
    LanguageEnum["de"] = "de";
    LanguageEnum["en"] = "en";
    LanguageEnum["es"] = "es";
    LanguageEnum["fi"] = "fi";
    LanguageEnum["fr"] = "fr";
    LanguageEnum["it"] = "it";
    LanguageEnum["ja"] = "ja";
    LanguageEnum["pr"] = "pr";
    LanguageEnum["pt"] = "pt";
    LanguageEnum["ru"] = "ru";
    LanguageEnum["zh"] = "zh";
})(LanguageEnum || (LanguageEnum = {}));
export var RiskEnum;
(function (RiskEnum) {
    RiskEnum["high"] = "high";
    RiskEnum["low"] = "low";
    RiskEnum["medium"] = "medium";
})(RiskEnum || (RiskEnum = {}));
export var SortByAlphabetEnum;
(function (SortByAlphabetEnum) {
    SortByAlphabetEnum["ATOZ"] = "ATOZ";
    SortByAlphabetEnum["ZTOA"] = "ZTOA";
})(SortByAlphabetEnum || (SortByAlphabetEnum = {}));
export var TargetCurrencyEnum;
(function (TargetCurrencyEnum) {
    TargetCurrencyEnum["cad"] = "cad";
    TargetCurrencyEnum["cny"] = "cny";
    TargetCurrencyEnum["eur"] = "eur";
    TargetCurrencyEnum["idr"] = "idr";
    TargetCurrencyEnum["inr"] = "inr";
    TargetCurrencyEnum["jpy"] = "jpy";
    TargetCurrencyEnum["krw"] = "krw";
    TargetCurrencyEnum["php"] = "php";
    TargetCurrencyEnum["rub"] = "rub";
    TargetCurrencyEnum["usd"] = "usd";
})(TargetCurrencyEnum || (TargetCurrencyEnum = {}));
export const SlimBetPartsFragmentDoc = gql `
	fragment SlimBetParts on SlimBet {
		_id
		game
		username
		playedAt
		amount
		multiplier
		profit
		currency
		softGameCat
		state {
			... on CasinoGameDice {
				target
				result
				condition
			}
			... on CasinoGameCrashState {
				gameId
			}
			... on CasinoGameWheel {
				risk
				result
				segments
			}
			... on CasinoGameMineState {
				minesCount
				mines
				rounds {
					field
					payoutMultiplier
				}
			}
		}
	}
`;
export const MyBetsQueryDoc = gql `
	query MyBetsQuery($limit: Int!) {
		myBets(limit: $limit) {
			...SlimBetParts
		}
	}
	${SlimBetPartsFragmentDoc}
`;
export const HighrollerBetsDoc = gql `
	query HighrollerBets($limit: Int!) {
		highrollerBets(limit: $limit) {
			...SlimBetParts
		}
	}
	${SlimBetPartsFragmentDoc}
`;
export const AllBetsDoc = gql `
	query AllBets($limit: Int!) {
		allBets(limit: $limit) {
			...SlimBetParts
		}
	}
	${SlimBetPartsFragmentDoc}
`;
export const FetchCoinPriceDoc = gql `
	query fetchCoinPrice($currency: FiatCurrencyEnum!) {
		fetchCoinPrice(FiatCurrency: $currency) {
			Fiat
			bnb
			btc
			dai
			doge
			eth
			ltc
			matic
			usdc
			usdt
			updatedAt
		}
	}
`;
export const MyBetsFeedDoc = gql `
	subscription MyBetsFeed {
		myBets {
			...SlimBetParts
		}
	}
	${SlimBetPartsFragmentDoc}
`;
export const OnNewAllBetDoc = gql `
	subscription onNewAllBet {
		allBets {
			...SlimBetParts
		}
	}
	${SlimBetPartsFragmentDoc}
`;
export const MyBetsQuery = (options) => {
    const q = client.watchQuery({
        query: MyBetsQueryDoc,
        ...options
    });
    var result = readable({ data: {}, loading: true, error: undefined, networkStatus: 1, query: q }, (set) => {
        q.subscribe((v) => {
            set({ ...v, query: q });
        });
    });
    return result;
};
export const AsyncMyBetsQuery = (options) => {
    return client.query({ query: MyBetsQueryDoc, ...options });
};
export const HighrollerBets = (options) => {
    const q = client.watchQuery({
        query: HighrollerBetsDoc,
        ...options
    });
    var result = readable({ data: {}, loading: true, error: undefined, networkStatus: 1, query: q }, (set) => {
        q.subscribe((v) => {
            set({ ...v, query: q });
        });
    });
    return result;
};
export const AsyncHighrollerBets = (options) => {
    return client.query({ query: HighrollerBetsDoc, ...options });
};
export const AllBets = (options) => {
    const q = client.watchQuery({
        query: AllBetsDoc,
        ...options
    });
    var result = readable({ data: {}, loading: true, error: undefined, networkStatus: 1, query: q }, (set) => {
        q.subscribe((v) => {
            set({ ...v, query: q });
        });
    });
    return result;
};
export const AsyncAllBets = (options) => {
    return client.query({ query: AllBetsDoc, ...options });
};
export const fetchCoinPrice = (options) => {
    const q = client.watchQuery({
        query: FetchCoinPriceDoc,
        ...options
    });
    var result = readable({ data: {}, loading: true, error: undefined, networkStatus: 1, query: q }, (set) => {
        q.subscribe((v) => {
            set({ ...v, query: q });
        });
    });
    return result;
};
export const AsyncfetchCoinPrice = (options) => {
    return client.query({ query: FetchCoinPriceDoc, ...options });
};
export const MyBetsFeed = (options) => {
    const q = client.subscribe({
        query: MyBetsFeedDoc,
        ...options
    });
    return q;
};
export const onNewAllBet = (options) => {
    const q = client.subscribe({
        query: OnNewAllBetDoc,
        ...options
    });
    return q;
};
export const PublicHistoryDoc = gql `
	query PublicHistory {
		getPublicHistory {
			betRoundId
			gameCode
			gameName
			providerSlug
			currency
			playerCurrency
			wagerTotal
			paidTotal
			netTotal
			wagerCurrency
			paidCurrency
			netCurrency
			roundStarted
			roundEnded
			createdAt
			updatedAt
		}
	}
`;
export const BetfeedDoc = gql `
	query Betfeed {
		betfeed {
			createdAt
			playerId
			currency
			username
			providerSlug
			providerName
			gameSlug
			gameName
			wagerTotal
			wagerTotalUsd
			paidTotal
			paidTotalUsd
			multiplier
		}
	}
`;
export const PublicHistory = (options) => {
    const q = client.watchQuery({
        query: PublicHistoryDoc,
        ...options
    });
    var result = readable({ data: {}, loading: true, error: undefined, networkStatus: 1, query: q }, (set) => {
        q.subscribe((v) => {
            set({ ...v, query: q });
        });
    });
    return result;
};
export const AsyncPublicHistory = (options) => {
    return client.query({ query: PublicHistoryDoc, ...options });
};
export const Betfeed = (options) => {
    const q = client.watchQuery({
        query: BetfeedDoc,
        ...options
    });
    var result = readable({ data: {}, loading: true, error: undefined, networkStatus: 1, query: q }, (set) => {
        q.subscribe((v) => {
            set({ ...v, query: q });
        });
    });
    return result;
};
export const AsyncBetfeed = (options) => {
    return client.query({ query: BetfeedDoc, ...options });
};
